const host = window.location.host;
export const subdomain = host.split(".")[0];